/**
 * Here should be all dayjs initialization logic, like
 * dayjs.extend, etc.
 * As server and client components are from two different contexts
 * we need to make sure that dayjs is initialized in both of them
 * in the same way.
 */

// eslint-disable-next-line no-restricted-imports
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default dayjs;
